import type { Vendor } from "src/types";

export const DEFAULT_VENDORS: Vendor[] = Array.from(Array(6).keys()).map(
  (item) => ({
    id: item,
    name: "Opensource",
    booth_size: "large",
    background_image: "/canvas/crosby/images/banner-placeholder.785ef5d8.jpg",
    image_url: "/canvas/crosby/images/logo-placeholder.1cd0f248.jpg",
    headline:
      "Open-source software is a type of computer software in which source code is released under a license in which the copyright holder grants.",
  })
);

export const CARD_BORDER_WIDTH = 2;
export const CARD_HORIZONTAL_GAP = 12;
export const CARD_VERTICAL_GAP = 24;
